import { useMutation } from '@connectrpc/connect-query'
import { exportDemandGroups } from '@ebalance/proto/bffuser/v1/demand_group_service-DemandGroupService_connectquery'

import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 需要グループ CSV エクスポート用の全件取得フック
 * (uploads/common.md §6 AC-DUC-028/029)。
 *
 * `useMutation` を使う (= ダウンロード
 * モーダルを開いた時の 1 回限りの命令的取得であり、 cache には載せない)。
 */
export function useExportDemandGroups(): InvalidatingMutationResultFor<
  typeof exportDemandGroups
> {
  return useMutation(exportDemandGroups)
}
